import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()

export default {

    pobierzLokalizacjeBusow(params) {
        return axios({
            method: 'get',
            url: URL + 'trasy/lokalizacjaBusow?'+params,
        });
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/lokalizacjaBusow/LokalizacjaBusowService.js